import UploadFiles from './uploadFiles';

export default UploadFiles;
